import { Popconfirm, Typography } from "antd";

interface IHrnDeleteConfirmProps {
  children?: any | null;
  onDelete: any | null;
}

const HrnDeleteConfirm = (props: IHrnDeleteConfirmProps) => {
  const { children, onDelete } = props;
  return (
    <Popconfirm
      placement="topRight"
      title={"Confirmation"}
      description={"Are you sure to delete?"}
      onConfirm={onDelete}
      okText={"Yes"}
      cancelText={"No"}
    >
      {children ? children : <Typography.Link style={{ whiteSpace: "nowrap" }}>{"Delete"}</Typography.Link>}
    </Popconfirm>
  );
};

export default HrnDeleteConfirm;
